module.exports = __webpack_public_path__ + "static/media/LI.64c4108b.svg";